import { RemoteObject } from './remote-object.model';

export enum SPHUserRole {
    Guest = 0,
    User = 1,
    Admin = 3,
    SuperAdmin = 5
}

export class SPHUser extends RemoteObject {
    public static fromJSON(json: any): SPHUser {
        const company = new SPHUser();

        Object.getOwnPropertyNames(company).forEach( (propertyName) => {
                company[propertyName] = json[propertyName];
        });

        company.remoteObjectCommonsFromJSON(json);

        return company;
    }

    public username: string = undefined;
    public fullname: string = undefined;
    public email: string = undefined;
    public mobile: string = undefined;
    public role: SPHUserRole = 0;
    public password: string = undefined;

    get isUniAdmin(): boolean {
        return this.role >= SPHUserRole.Admin;
    }

    public toJSON(): any {
        const json = {};
        this.remoteObjectCommonsToJson(json);
        Object.getOwnPropertyNames(this).forEach( (propertyName) => {
            json[propertyName] = this[propertyName];
        });
        return json;
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/sph-user.model.ts